/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");
var jQuery = require("jquery");

// Older browsers support
import 'babel-polyfill';
import 'es6-promise/auto';
import 'formdata-polyfill';
import 'url-polyfill';

// Theme SCSS files
import '../../styles/theme.scss';
import '../../styles/theme.scss.liquid';

// Vue.js core
import Vue from 'vue';

// Bootstrap Framework
import 'bootstrap';

// Spinners
// https://epic-spinners.epicmax.co/#/get-started
import 'epic-spinners/dist/lib/epic-spinners.min.css';
import {HollowDotsSpinner} from 'epic-spinners/dist/lib/epic-spinners.min.js';

// Other libraries
import Vue2TouchEvents from 'vue2-touch-events';
import VueMatchHeights from 'vue-match-heights';
// import VueInstagram from 'vue-instagram';

// allow inline javascript code to be executed by using '<script2></script2>' tag
import VueScript2 from 'vue-script2';

// Lazysizes plugin for lazyloading
import 'lazysizes';
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks'; // bg images support extension
import 'lazysizes/plugins/bgset/ls.bgset'; // responsive bg images support extension
import 'lazysizes/plugins/parent-fit/ls.parent-fit'; // parent fit extension

// Store => common data objects
import store from '../store/store';

import 'jquery-nice-select/js/jquery.nice-select';
// import tippy from 'tippy';
// import 'tippy.js/dist/tippy.css';

// mixins
import helperMethods from '../mixins/helpers';
import layoutMethods from '../mixins/layout';
import blogMethods from '../mixins/blog';
import cartMethods from '../mixins/cart';
import collectionMethods from '../mixins/collection';
import collectionListMethods from '../mixins/list-collections';
import productMethods from '../mixins/product';
// import accountMethods from '../mixins/account';
// import recentlyViewedMethods from '../mixins/recentlyViewed';
import productReviewsMethods from '../mixins/productReviews';
import sectionMethods from '../mixins/section';
import customMethods from '../mixins/custom';

let app;

// register components in Vue
Vue.use(VueScript2);
Vue.use(Vue2TouchEvents);
Vue.use(VueMatchHeights);

// Create new Vue instance
new Vue({
  el: '#app',
  delimiters: ['${', '}'],

  components: {
    HollowDotsSpinner,
  },
  mixins: [
    helperMethods,
    layoutMethods,
    blogMethods,
    cartMethods,
    collectionMethods,
    collectionListMethods,
    productMethods,
    productReviewsMethods,
    sectionMethods,
    customMethods,
  ],

  data() {
    return store; // shared data
  },

  beforeCreate() {
    // $('.shopify-challenge__container').detach().appendTo('[data-app-scripts]');
    $('#additional-checkout-buttons iframe').addClass('d-none').detach()
      .appendTo('[data-app-scripts]');
    $('#app script').detach().appendTo('[data-app-scripts]');
    $('#app style').detach().appendTo('[data-app-scripts]');
    if ($(window).width() < 1025) {
      $('[data-desktop_navbar]').remove();
    } else {
      $('[data-mobile_navbar]').remove();
    }
  },
  mounted() {
    app = this;
    window.app = app;
    window.slate = window.slate || {};
    window.theme = window.theme || {};

    // initialization methods
    app._getCurrentTemplate();
    app._initLayout(); // various functions related to layout, e.g. initialize Bootstrap specific components etc
    app._initCart(); // everything cart related, e.g. add product to cart etc

    if (app.currentTemplate === 'blog-article-topics') {
      app._initBlog(); // everything related to the blog pages
    }

    if (app.currentTemplate === 'collection') {
      app._initCollection(); // everything related to the collection pages, e.g. collection filtering etc
    }

    // if (app.currentTemplate === 'list-collections') {
    //   app._initListCollection(); // everything related to the list of collection pages, e.g. collection filtering etc
    // }

    if (app.currentTemplate === 'product') {
      app._initProduct(); // everything related to the product page, e.g. variant selection, product options, galleries etc
    }
    $(window).on('load', () => {
      app._initTheme();
    });
  },

  methods: {
    _initTheme() {
      app._initProductReviews(); // product reviews functionality
      app._initSection(); // Shopify admin sections & blocks => interaction between theme JavaScript and the theme editor
      app._initCustomMethods(); // custom JS code
    },
  },
});

